import { ViolationType } from "@payment-ui/interfaces";

// common constants
export const OTHER = "Other";
export const OTHER_AMOUNT = -1;
export const DEFAULT_VALIDATION_INFO = {
    type: ViolationType.NONE,
    message: "",
    showSwiggyMoneyInfoHalfCard: false,
};

// 3.0 specific constants
export const ADD_MONEY_PAGE_LOGO = "swiggy_pay/SwiggyMoneyLogoAddMoneyPage";

// 4.0 specific constants
export const SWIGGY_MONEY_HEADER_TEXTS_V4 = {
    haveVoucher: "Have a gift voucher?",
    redeemNow: "Redeem Now",
    recommendedText: "{0} Recommended based on your order history",
    addMoneyLimit: "You can add upto a maximum of ₹{0}",
    currentBalance: "Total Balance: ₹{0}",
    addMoneyCtaText: "Proceed to Add Balance",
    defaultPlaceHolderOnCustomAmount: "Enter Amount",
    notesHeader: "Note:",
    accessbilityAddMoneyText: "Proceed to Add {0} rupees to Swiggy Money",
};

export const ADD_MONEY_PAGE_LOGO_V4 = "4_0_Assets/Money/SwiggyAddMoneyLogo.png";
export const ADD_MONEY_PAGE_BACKGROUND_V4 = "4_0_Assets/Money/SMbg.png";
